export function replaceLocation(url: string) {
  window.location.replace(url)
}



// WEBPACK FOOTER //
// ./src/libs/replaceLocation/index.ts